import {
  bundlesWithVisibleLanguage,
  bundlesWithHiddenGlobally
} from "#blokkli/default-global-options";
import { BK_HIDDEN_GLOBALLY, BK_VISIBLE_LANGUAGES } from "../symbols.js";
export function mapCheckboxTrue(v) {
  return v === true || v === "1" || v === 1 || v === "true" ? "1" : "0";
}
export function getRuntimeOptionValue(definition, value) {
  if (definition.type === "checkbox") {
    return mapCheckboxTrue(value) === "1";
  } else if (definition.type === "radios") {
    if (typeof value === "string") {
      return value;
    }
    return "";
  } else if (definition.type === "checkboxes") {
    if (typeof value === "string") {
      return value.split(",");
    } else if (Array.isArray(value)) {
      return value;
    }
    return [];
  } else if (definition.type === "range" || definition.type === "number") {
    if (typeof value === "number" && !Number.isNaN(value)) {
      return value;
    } else if (typeof value === "string") {
      const parsed = Number.parseFloat(value);
      if (!Number.isNaN(parsed)) {
        return parsed;
      }
    }
  }
  if (typeof value === "string") {
    return value;
  }
  return "";
}
export function isVisibleByOptions(item, language) {
  if (!item) {
    return false;
  }
  if (item.options) {
    if (bundlesWithHiddenGlobally.includes(item.bundle) && mapCheckboxTrue(item.options[BK_HIDDEN_GLOBALLY]) === "1") {
      return false;
    }
    if (bundlesWithVisibleLanguage.includes(item.bundle)) {
      const option = item.options[BK_VISIBLE_LANGUAGES];
      if (language && option && typeof option === "string") {
        const languages = option.split(",");
        if (languages.length && !languages.includes(language)) {
          return false;
        }
      }
    }
  }
  return true;
}
